import React from 'react';
import { Provider } from 'react-redux';
import { message, Spin } from 'antd';
import { renderRoutes } from 'react-router-config';
import { ConnectedRouter } from 'connected-react-router';
import { QueryClient, QueryClientProvider } from 'react-query';
import store from '@src/store';
import { history, routes } from '@src/router';
import Layout from '@src/layouts/BaseLayout';
import { useUserProfile } from '@src/service/apis/system';
import NoAccess from '@src/components/NoAccess';

message.config({
  duration: 3,
  maxCount: 3,
  // Since all message import form antdV4 add the custom prefix.
  prefixCls: 'mds-ant-message',
});

console.log('Current ENV: ' + process.env.REACT_APP_ENV);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

const AppContent = () => {
  const { data: userProfile, isLoading } = useUserProfile();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin spinning={isLoading} tip="Loading" />
      </div>
    );
  }

  if (!userProfile?.mds_enabled) {
    return <NoAccess />;
  }

  return <Layout>{renderRoutes(routes)}</Layout>;
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <AppContent />
        </ConnectedRouter>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
